import { render, staticRenderFns } from "./AdjustColumns.vue?vue&type=template&id=29714df1"
import script from "./AdjustColumns.vue?vue&type=script&lang=js"
export * from "./AdjustColumns.vue?vue&type=script&lang=js"
import style0 from "./AdjustColumns.vue?vue&type=style&index=0&id=29714df1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports